// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PeriodUserQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET payroll list endpoints scoped by period_id with an
 * optional user_id filter, read from the query string.
 *
 * period_id is nullable so the controller keeps its existing
 * "period_id obrigatório" guard (preserving the legacy error message).
 * user_id is an optional filter.
 *
 * Shared by:
 * - GET /payroll/deductions?period_id=X[&user_id=Y]
 * - GET /payroll/advances?period_id=X[&user_id=Y]
 */
import { registerContract } from './validate'

export interface Payroll_PeriodUserQueryInput {
period_id?: number
user_id?: string
}

registerContract('Payroll_PeriodUserQueryInput', {
  period_id: { type: 'number',  required: false },
  user_id:   { type: 'string',  required: false },
})
